package com.appcreator.client.firebase.auth

import dev.gitlive.firebase.auth.FirebaseUser

internal actual suspend fun platformPreDelete(user: FirebaseUser) {
}